import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GetTagsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  shortErrorMessage?: string
  children?: (data: GetTagsResponse) => ReactElement
  onSuccess?: (data: GetTagsResponse) => void
}

const GetTestConfigTags = ({
  shortErrorMessage,
  children,
  onSuccess
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/tags`

  const { requestParams } = useGetParamsWithSpaceId<undefined>(undefined)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetTestConfigTags
